// extracted by mini-css-extract-plugin
export default {"container":"LFRKo9","topDivider":"Oh0Ztr","hideDivider":"lXJ3NI","listHoveredBorderColor":"jVBq6Q","backgroundColor":"ZqUlMC"};